import { useQuery } from '@apollo/client';
import { gql } from '@eti/schema-types';

export const SELF_SERVICE_REBOOKING_QUERY = gql(/* GraphQL */ `
  query getSelfServiceRebooking {
    selfServiceRebooking {
      criteria
      customerContact {
        firstName
        lastName
        contact {
          email
          phone {
            countryCallingCode
            numberWithoutCountryCode
          }
        }
      }
      customerContactUnmodifiable
      translations {
        key
        translation
        origin
      }
      travelers {
        id
        ageType
        birthDate
        firstName
        lastName
        gender
      }
      travelersUnmodifiable
      validatingCarriers
      voucherAvailable
    }
  }
`);

const useSelfServiceRebooking = () => {
  const { data, loading } = useQuery(SELF_SERVICE_REBOOKING_QUERY);

  const selfServiceRebookingValidatingCarriers =
    data?.selfServiceRebooking?.validatingCarriers || [];
  const selfServiceRebookingCriteria = data?.selfServiceRebooking?.criteria || [];
  const selfServiceRebookingTravelers = data?.selfServiceRebooking?.travelers || [];
  const selfServiceRebookingContact =
    data?.selfServiceRebooking?.customerContact?.contact || undefined;
  const isSelfServiceRebooking = data?.selfServiceRebooking?.voucherAvailable || false;
  const customerContactUnmodifiable =
    data?.selfServiceRebooking?.customerContactUnmodifiable || false;
  const travelersUnmodifiable = data?.selfServiceRebooking?.travelersUnmodifiable || false;

  return {
    customerContactUnmodifiable,
    isSelfServiceRebooking,
    loading,
    selfServiceRebookingContact,
    selfServiceRebookingCriteria,
    selfServiceRebookingTravelers,
    selfServiceRebookingValidatingCarriers,
    translations: data?.selfServiceRebooking?.translations || [],
    travelersUnmodifiable,
  };
};

export default useSelfServiceRebooking;
